import React from 'react';

function SkeletonRow() {
  return (
    <div className="table-row skeleton">
      <div className="cell user">
        <div className="avatar-skel" />
        <div className="lines">
          <div className="line w-80" />
          <div className="line w-40" />
        </div>
      </div>
      <div className="cell"><div className="line w-50" /></div>
      <div className="cell tags">
        <div className="tag-skel" />
        <div className="tag-skel" />
        <div className="tag-skel" />
      </div>
      <div className="cell"><div className="line w-30" /></div>
      <div className="cell"><div className="line w-20" /></div>
      <div className="cell rating"><div className="line w-20" /></div>
      <div className="cell expertise"><div className="line w-90" /></div>
    </div>
  );
}

export default SkeletonRow;


